import React from 'react'; // Removed unused hooks
import styled from 'styled-components';

import { DataElementContext } from '@/page-components/common/DataElementContext';
import { processComponentProps } from '@/page-components/utils/processComponentProps';
import useSliderRangeInput from './hooks/useSliderRangeInput';

type SliderRangeProps = {
  children: any;
  styleText: string;
  className: string;
  properties?: any;
};

const ModuleElementDiv = styled.div<{ $styleText: string }>((props) => props.$styleText);

const SliderRange = (componentProps: SliderRangeProps) => {
  let props = componentProps;

  const initialDataElementContext = React.useContext(DataElementContext);

  [props] = processComponentProps(props, initialDataElementContext);
  const processedDataElementContext = initialDataElementContext;

  const contextValue = useSliderRangeInput(processedDataElementContext);

  return (
    <ModuleElementDiv className={componentProps.className ?? ''} $styleText={componentProps.styleText}>
      <DataElementContext.Provider value={contextValue}>{componentProps.children}</DataElementContext.Provider>
    </ModuleElementDiv>
  );
};

export default SliderRange;
